export const dashboardMock = {
    alerts: {
        data: [
            { answered: 1441, not_handled: 67, in_progress: 52, closed: 59 }
        ]
    },
    nps: { data: [{ nps: 30, promoters: 60, detractors: 20, passives: 10 }] },
    npsHist: {
        data: [
            {
                serie: [33, 41, 24],
                labels: ["ENE", "FEB", "MAR"]
            }
        ]
    },
    satisfaction: {
        data: [
            {
                value: 80,
                deviation: 2
            }
        ]
    },
    offerSampler: {
        data: [
            {
                value: 40,
                group: "si"
            },
            {
                value: 60,
                group: "no"
            }
        ]
    },
    satisfactionHist: {
        data: [
            {
                serie: [64, 64, 64],
                labels: ["ENE", "FEB", "MAR"]
            }
        ]
    },
    offerSamplerHist: {
        data: [
            {
                serie: [30, 90, 50],
                labels: ["ENE", "FEB", "MAR"]
            }
        ]
    },
    willingnessToReturn: {
        data: [
            {
                value: 25,
                deviation: 1
            }
        ]
    },
    willingnessToReturnHist: {
        data: [
            {
                serie: [64, 63, 62],
                labels: ["ENE", "FEB", "MAR"]
            }
        ]
    },
    environment: {
        data: [
            {
                value: 80,
                deviation: 3
            }
        ]
    },
    drink: {
        data: [
            {
                value: 80.6,
                deviation: 2
            }
        ]
    },
    food: {
        data: [
            {
                value: 40,
                deviation: 2
            }
        ]
    },
    service: {
        data: [
            {
                value: 0,
                deviation: 1
            }
        ]
    },
    willingnessToRecommend: {
        data: [
            {
                value: 80,
                deviation: 3
            }
        ]
    },
    willingnessToRecommendHist: {
        data: [
            {
                serie: [64, 64, 64],
                labels: ["ENE", "FEB", "MAR"]
            }
        ]
    },
    experience: {
        data: [
            {
                general: { name: "General Experience", value: 90 },
                loyalty: { name: "Loyalty", value: 76, old: 75 },
                experiences: [
                    { name: "Brand Experience", value: 80, old: 80 },
                    { name: "Critical Moment Experience", value: 95, old: 83 },
                    { name: "Cont Experience", value: 75, old: 55 }
                ]
            }
        ]
    },
    experienceHist: {
        data: [
            {
                serie: [
                    {
                        value: 64,
                        loyalty: 73,
                        general: 67,
                        brand: 74,
                        critical_moment: 31,
                        continuous_experience: 87
                    },
                    {
                        value: 65,
                        loyalty: 70,
                        general: 62,
                        brand: 75,
                        critical_moment: 31,
                        continuous_experience: 87
                    },
                    {
                        value: 50,
                        loyalty: 67,
                        general: 57,
                        brand: 60,
                        critical_moment: 50,
                        continuous_experience: 40
                    }
                ],
                labels: ["ENE", "FEB", "MAR"]
            }
        ]
    },
    sentimentAnalysis: {
        data: [
            {
                negative: 8,
                count: 10,
                neutral: 1,
                positive: 1,
                group: "COMIDA",
                tags: [
                    {
                        negative: 8,
                        count: 10,
                        neutral: 1,
                        positive: 1,
                        group: "COMIDA"
                    }
                ]
            },
            {
                negative: 1,
                count: 10,
                neutral: 0,
                positive: 9,
                group: "TRANSPORTE",
                tags: [
                    {
                        negative: 1,
                        count: 10,
                        neutral: 0,
                        positive: 9,
                        group: "AUTOBUS"
                    }
                ]
            }
        ]
    },
    sentimentComments: {
        data: [
            {
                score: 54,
                comment: "autobus mal, almuerzo bien"
            },
            {
                score: 0,
                comment: "autobus bien, la comida tambine"
            }
        ]
    },

    lastComments: {
        data: [
            {
                createdAt: "06/08/2018",
                comment: "Very good appearance"
            },
            {
                createdAt: "06/08/2018",
                comment: "He could not solve my problem"
            },
            {
                createdAt: "06/08/2018",
                comment: "Very grateful for the help"
            },
            {
                createdAt: "06/08/2018",
                comment: "He lost time talking about personal scares"
            },
            {
                createdAt: "06/08/2018",
                comment: "He was very good."
            }
        ]
    },
    satisfactionByChannel: {
        data: [
            { group: "Mobile App", value: 54 },
            { group: "Electronic Banking", value: 35 },
            { group: "Office", value: 45 },
            { group: "Phone", value: 30 }
        ]
    },
    experienceByTerritory: {
        data: [
            {
                challenge: "BRASIL",
                challengeValue: 27,
                best: "ARGENTINA",
                bestValue: 89,
                groups: [
                    { group: "BRASIL", value: 27 },
                    { group: "ARGENTINA", value: 89 }
                ]
            }
        ]
    },
    /**
     * TODO https://trello.com/c/L0kX9Me4/24-modificar-modelo-de-datos-para-el-podio-del-dashboard
     * Idem experienceByTerritory
     */
    experienceByPointSale: {
        data: [
            {
                best: "Oficina1-3", // best point of sale
                challenge: "Oficina1-2", // point of sale to improve
                groups: [
                    { group: "Oficina1-2", value: 60 },
                    { group: "Oficina1-2", value: 53 },
                    { group: "Oficina1-3", value: 70 }
                ]
            }
        ]
    },
    experienceByCriticalMoment: {
        data: [
            {
                best: "Segment 3", // our best
                challenge: "Segment 2", // our challenge
                groups: [
                    { group: "Segment 1", value: 60 },
                    { group: "Segment 2", value: 53 },
                    { group: "Segment 3", value: 70 }
                ]
            }
        ]
    }
}


// WEBPACK FOOTER //
// ./src/config/data/mocks.js